export default __webpack_public_path__ + "static/quality-e4f7696fd707641dd2c2709f717fa4ef.svg";